import { AdCreator, IAdCreator } from "../AdCreator";
import "./AdCreators.scss";

interface IAdCreators {
  title: string;
  creators: IAdCreator[];
}

export const AdCreators = ({
  title,
  creators,
}: IAdCreators) => {
  return (
    <div className="AdCreators">
      <h3 className="title">{title}</h3>
      <div className="grid">
        {creators.map((creator) => (
          <AdCreator
            key={creator.name}
            name={creator.name}
            link={creator.link}
            image={creator.image}
            handleClick={creator.handleClick}
          />
        ))}
      </div>
    </div>
  );
};
